


import { Component, Vue } from 'vue-property-decorator';
import FlatSelectorSwitch, {
  FlatSelectorSwitchColorSeparator,
} from '@/shared/components/flat-selector-switch.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';

@Component({
    components: {
        FlatSelectorSwitch,
        Icon,
    },
})

export default class PartialFlatSelectorSwitch extends Vue {
  private flatSelectorSwitchColorSeparator = FlatSelectorSwitchColorSeparator;
  private iconEnum = IconEnum;


  private clickElement() {
    alert('click element');
  }
}
